import React, { useState, useContext } from "react";
import checkoutStyles from "./Checkout.module.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import axios from "axios";

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cart, clearCart } = useContext(CartContext);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    district: "",
    street: "",
    building: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Breadcrumb logic
  const pathSegments = location.pathname.split("/").filter(Boolean);
  let currentPath = "";
  const crumbs = pathSegments.map((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === pathSegments.length - 1;

    return (
      <span key={currentPath}>
        {isLast ? (
          <span>{segment.charAt(0).toUpperCase() + segment.slice(1)}</span>
        ) : (
          <>
            <Link to={currentPath}>{segment}</Link>
            <span> / </span>
          </>
        )}
      </span>
    );
  });

  // Calculate totals
  const subtotal = cart.reduce((acc, product) => {
    const price = product.price || 0;
    const quantity = product.quantity || 1;
    return acc + price * quantity;
  }, 0);

  const deliveryFee = 4.0;
  const total = subtotal + deliveryFee;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\+?[\d\s-()]+$/.test(formData.phone)) {
      newErrors.phone = "Invalid phone number format";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Full address is required";
    }

    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    if (!formData.district.trim()) {
      newErrors.district = "District is required";
    }

    if (!formData.street.trim()) {
      newErrors.street = "Street is required";
    }

    if (!formData.building.trim()) {
      newErrors.building = "Building is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    console.log("HEREEEEEEEEEEEE");
    e.preventDefault();

    if (validateForm()) {
      console.log("HEREEEEEEEEEEEE11111");
      setIsLoading(true);

      try {
        // Transform cart items to match API expected format
        const items = cart.map((item) => ({
          product: item._id,
          quantity: item.quantity || 1,
          size: item.selectedSize || item.size || null,
        }));

        // Transform form data to match your backend service expectations
        const shippingAddress = {
          name: formData.name.trim(),
          email: formData.email.trim(),
          phone: formData.phone.trim(),
          address: formData.address.trim(),
          city: formData.city.trim(),
          district: formData.district.trim(),
          street: formData.street.trim(),
          building: formData.building.trim() || "",
        };

        const orderData = {
          items,
          shippingAddress,
          deliveryFee: deliveryFee,
          subtotal: subtotal,
          total: total,
        };

        console.log("Sending order data:", JSON.stringify(orderData, null, 2));

        // Make API call to create order
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}order/createOrder`,
          orderData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log("API Response:", response.data);

        if (
          response.data.message === "Order created successfully" &&
          response.data.order
        ) {
          const savedOrder = response.data.order;

          console.log("Order created:", savedOrder);

          // Clear the cart
          if (clearCart) {
            clearCart();
          }

          // Redirect to success page
          navigate("/", {
            state: {
              orderId: savedOrder._id,
              orderData: savedOrder,
            },
          });
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error placing order:", error);
        console.error("Error response:", error.response?.data);

        if (error.response && error.response.data) {
          const errorData = error.response.data;

          if (errorData.error) {
            alert(`Error: ${errorData.error}`);
          } else if (errorData.message) {
            alert(`Error: ${errorData.message}`);
          } else {
            alert("Server error occurred. Please try again.");
          }
        } else if (error.request) {
          alert("Network error. Please check your connection and try again.");
        } else {
          alert(`Error: ${error.message}`);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (cart.length === 0) {
    return (
      <section className={checkoutStyles.checkoutcontainer}>
        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              <div className="text-center py-5">
                <h2>Your cart is empty</h2>
                <p>Add some items to your cart before checkout.</p>
                <Link to="/shop">
                  <Button variant="dark">Continue Shopping</Button>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  return (
    <section className={checkoutStyles.checkoutcontainer}>
      <Container fluid className="py-4">
        <Row>
          {/* Breadcrumb */}
          <Col lg={12} className="border-top border-tertiary py-lg-4 py-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb" style={{ fontSize: "14px" }}>
                <li className="breadcrumb-item me-2">
                  <Link to="/" className="text-decoration-none text-muted">
                    Home
                  </Link>
                </li>
                <span className="me-2">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.53073 2.46937L11.5307 7.46937C11.6007 7.53905 11.6561 7.62184 11.694 7.71301C11.7318 7.80417 11.7513 7.90191 11.7513 8.00062C11.7513 8.09933 11.7318 8.19707 11.694 8.28824C11.6561 8.3794 11.6007 8.46219 11.5307 8.53187L6.53073 13.5319C6.38984 13.6728 6.19874 13.7519 5.99948 13.7519C5.80023 13.7519 5.60913 13.6728 5.46823 13.5319C5.32734 13.391 5.24818 13.1999 5.24818 13.0006C5.24818 12.8014 5.32734 12.6103 5.46823 12.4694L9.93761 8L5.46761 3.53062C5.32671 3.38973 5.24756 3.19863 5.24756 2.99937C5.24756 2.80011 5.32671 2.60902 5.46761 2.46812C5.60851 2.32723 5.7996 2.24807 5.99886 2.24807C6.19812 2.24807 6.38921 2.32723 6.53011 2.46812L6.53073 2.46937Z"
                      fill="black"
                      fillOpacity="0.6"
                    />
                  </svg>
                </span>
                <li className="breadcrumb-item me-2">
                  <Link to="/cart" className="text-decoration-none text-muted">
                    Cart
                  </Link>
                </li>
                <span className="me-2">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.53073 2.46937L11.5307 7.46937C11.6007 7.53905 11.6561 7.62184 11.694 7.71301C11.7318 7.80417 11.7513 7.90191 11.7513 8.00062C11.7513 8.09933 11.7318 8.19707 11.694 8.28824C11.6561 8.3794 11.6007 8.46219 11.5307 8.53187L6.53073 13.5319C6.38984 13.6728 6.19874 13.7519 5.99948 13.7519C5.80023 13.7519 5.60913 13.6728 5.46823 13.5319C5.32734 13.391 5.24818 13.1999 5.24818 13.0006C5.24818 12.8014 5.32734 12.6103 5.46823 12.4694L9.93761 8L5.46761 3.53062C5.32671 3.38973 5.24756 3.19863 5.24756 2.99937C5.24756 2.80011 5.32671 2.60902 5.46761 2.46812C5.60851 2.32723 5.7996 2.24807 5.99886 2.24807C6.19812 2.24807 6.38921 2.32723 6.53011 2.46812L6.53073 2.46937Z"
                      fill="black"
                      fillOpacity="0.6"
                    />
                  </svg>
                </span>
                {crumbs}
              </ol>
            </nav>
          </Col>

          {/* Page Title */}
          <div className="mb-3">
            <h2 className={`${checkoutStyles.checkouttitle} text-uppercase`}>
              Checkout
            </h2>
          </div>

          {/* Main Content */}
          <Col lg={7} className="mb-lg-0 mb-3">
            <Card className="rounded-4 border border-tertiary">
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                  {/* Customer Information */}
                  <div className="mb-4">
                    <h3 className="fw-semibold mb-3">Customer Information</h3>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Full Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            isInvalid={!!errors.name}
                            className="rounded-3"
                            placeholder="Enter your full name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Email Address
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            isInvalid={!!errors.email}
                            className="rounded-3"
                            placeholder="Enter your email address"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={12} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Phone Number
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            isInvalid={!!errors.phone}
                            className="rounded-3"
                            placeholder="Enter your phone number"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  {/* Address Information */}
                  <div className="mb-4">
                    <h3 className="fw-semibold mb-3">Address Information</h3>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Governorate
                          </Form.Label>
                          <Form.Select
                            name="district"
                            value={formData.district}
                            onChange={handleInputChange}
                            isInvalid={!!errors.district}
                            className="rounded-3"
                          >
                            <option value="">Select Governorate</option>
                            <option value="Beirut">Beirut</option>
                            <option value="Mount Lebanon">Mount Lebanon</option>
                            <option value="Beqaa">Beqaa</option>
                            <option value="South Lebanon">South Lebanon</option>
                            <option value="Nabatieh">Nabatieh</option>
                            <option value="North Lebanon">North Lebanon</option>
                            <option value="Akkar">Akkar</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.district}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">City</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleInputChange}
                            isInvalid={!!errors.city}
                            className="rounded-3"
                            placeholder="Enter city"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.city}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={8} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">Street</Form.Label>
                          <Form.Control
                            type="text"
                            name="street"
                            value={formData.street}
                            onChange={handleInputChange}
                            isInvalid={!!errors.street}
                            className="rounded-3"
                            placeholder="Enter street name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.street}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Building
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="building"
                            value={formData.building}
                            onChange={handleInputChange}
                            isInvalid={!!errors.building}
                            className="rounded-3"
                            placeholder="Building #"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.building}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={12} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Full Address
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            isInvalid={!!errors.address}
                            className="rounded-3"
                            placeholder="Enter your complete address"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          {/* Order Items and Order Summary */}
          <Col lg={5}>
            {/* Order Items */}
            <Card className="rounded-4 border border-tertiary mb-3">
              <Card.Body>
                <div className="mb-3">
                  <h3 className="fw-semibold mb-3">Order Items</h3>
                  {cart.map((product, index) => (
                    <div
                      key={product._id}
                      className={`d-flex align-items-center ${
                        index < cart.length - 1
                          ? "border-bottom border-tertiary pb-3 mb-3"
                          : ""
                      }`}
                    >
                      <Image
                        src={
                          product.image ||
                          product.image_link ||
                          "https://via.placeholder.com/60"
                        }
                        width={60}
                        height={60}
                        className="rounded-3 me-3"
                        style={{ objectFit: "cover" }}
                      />
                      <div className="flex-grow-1">
                        <h5 className="fw-medium mb-1 text-capitalize">
                          {product.title || product.Title || "Unknown Product"}
                        </h5>
                        {(product.selectedColor || product.selectedSize) && (
                          <div className="small text-muted mb-1">
                            {product.selectedColor && (
                              <span>Color: {product.selectedColor}</span>
                            )}
                            {product.selectedColor && product.selectedSize && (
                              <span> | </span>
                            )}
                            {product.selectedSize && (
                              <span>Size: {product.selectedSize}</span>
                            )}
                          </div>
                        )}
                        <div className="small text-muted">
                          Qty: {product.quantity || 1}
                        </div>
                      </div>
                      <div className="text-end">
                        <div className="fw-semibold">
                          $
                          {(
                            (product.price || 0) * (product.quantity || 1)
                          ).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>

            {/* Order Summary */}
            <Card className="rounded-4 border border-tertiary">
              <Card.Body>
                <div className="mb-3">
                  <h3 className="fw-semibold">Order Summary</h3>
                </div>

                <div className="d-flex justify-content-between pb-3 border-bottom border-tertiary">
                  <span className={`${checkoutStyles.checkouttext} d-block`}>
                    Subtotal
                  </span>
                  <span
                    className={`${checkoutStyles.checkoutnumbertext} d-block`}
                  >
                    ${subtotal.toFixed(2)}
                  </span>
                </div>

                <div className="d-flex justify-content-between pb-3 border-bottom border-tertiary">
                  <span className={`${checkoutStyles.checkouttext} d-block`}>
                    Delivery Fee
                  </span>
                  <span
                    className={`${checkoutStyles.checkoutnumbertext} d-block`}
                  >
                    ${deliveryFee.toFixed(2)}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center py-3">
                  <span
                    className={`${checkoutStyles.checkoutnumbertext} d-block fw-normal`}
                  >
                    Total
                  </span>
                  <span
                    className={`${checkoutStyles.checkouttotaltext} d-block`}
                  >
                    ${total.toFixed(2)}
                  </span>
                </div>

                <Button
                  variant="dark"
                  className={`${checkoutStyles.checkoutbtn} d-block w-100`}
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Placing Order..." : "Place Order"}
                </Button>

                <div className="text-center mt-3">
                  <Link
                    to="/cart"
                    className="text-decoration-none text-muted small"
                  >
                    ← Back to Cart
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Checkout;